module.exports = __webpack_public_path__ + "Flag-729.b4ea474766455d66b87364e482a7c1af.svg";